import { render, staticRenderFns } from "./ReciclajeSecurity.vue?vue&type=template&id=06688b47"
import script from "./ReciclajeSecurity.vue?vue&type=script&lang=js"
export * from "./ReciclajeSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports